/************************************************************
 Diagnosis Namespace
 ************************************************************/

window.diagnosisNS = {

    searchDiagnosisModal: function (callback, params) {
        const _callback = callback;
        const _params = params;
        Hades.showLoading();

        $.get('/diagnosis/search_diagnosis_modal', {width: $(window).width(), height: $(window).height()}, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({content: data, autoScale: true, autoDimensions: true});

                $('#diagnosis-search-modal-ct').on('onDiagnoseConfirm', function (evt, data) {

                    _callback(evt, data, _params);
                });
                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
            });
    },

    searchMultipleDiagnosisModal: function (callback, params) {
        Hades.showLoading();

        $.get('/diagnosis/search_multiple_diagnosis_modal', {items: null, width: $(window).width(), height: $(window).height()}, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({content: data});
                $('#diagnosis-multiple-search-modal-ct').bind('diagnosisSelected', function (evt, data) {callback(evt, data, params)});

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
            });
    }
}

